import React from 'react'

export const ArrowRightVector = () => (
   <svg
      className="MIRECO-arrow-right"
      width="24"
      height="24"
      viewBox="0 0 6.3499998 6.3499998"
      version="1.1"
   >
      <g
         transform="translate(0,-290.65)"
      >
         <path
            style={{
               fill: 'none',
               stroke: '#333333',
               strokeWidth: 0.52916667,
               strokeLinecap: 'butt',
               strokeLinejoin: 'miter',
               strokeMiterlimit: 4,
               strokeDasharray: 'none',
               strokeOpacity: 1,
            }}
            d="m 3.1749998,292.2375 1.5875001,1.5875 -1.5875001,1.5875"
         />
         <path
            style={{
               fill: 'none',
               stroke: '#333333',
               strokeWidth: 0.529167,
               strokeDasharray: 'none',
               strokeOpacity: 1,
            }}
            d="m 3.4395833,293.825 -2.1166667,0"
         />
      </g>
   </svg>
)
